import React, { useState } from 'react';
import { PUBLIC_PATH } from '../../../../../shared/config/routes-config';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import { trackEvent } from '../../../../../shared/services/utils/tracking/tracking.service';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { ConfirmModal } from '../confirm-modal/confirm-modal.component';
import { UnitTypeUiModel } from '../../../../../shared/ui-models/unit-type.ui-model';
import { AccountManagerPersonModal } from '../../../unit-types-list/components/assign-accountManager-modal/assign-accountManager-modal.component';

export interface AccountManagerInfoProps {
  data: {
    accountManagerName: string;
    accountManagerId: string;
    accountManagerEmail: string;
    accountManagerPhone: string;
    propertyId: string;
  };
  eventHandlers: {
    addAccountManager: (data: Partial<UnitTypeUiModel>) => void;
    deleteAccountManager: () => void;
  };
}
export const AccountManagerInfo: React.FC<AccountManagerInfoProps> = ({ data, eventHandlers }) => {
  const isMobileView = useWindowResizer();
  const [showAccountManagerUserModal, setShowAccountManagerUserModal] = useState<boolean>(false);
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  return (
    <>
      <div className="flex-1 mt-4 pb-8 rounded-lg bg-white shadow-md p-6 w-full">
        {data?.accountManagerId ? (
          <>
            <div className="font-bold text-gray-800 font-gilroy-medium text-2xl mb-6 pb-3">
              Account Manager Info
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col">
                <span className="text-base uppercase text-gray-500 font-medium">Name</span>
                <span className="text-gray-800 font-medium">{data?.accountManagerName}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-base uppercase text-gray-500 font-medium">Email :</span>
                <span className="text-gray-800 font-medium">{data?.accountManagerEmail}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-base uppercase text-gray-500 font-medium">Phone :</span>
                <span className="text-gray-800 font-medium">{data?.accountManagerPhone}</span>
              </div>
            </div>

            <div className="flex justify-end mt-6 gap-3">
              <Button
                onClick={() => setShowAccountManagerUserModal(true)}
                tracking={{
                  action: 'cancel',
                  category: '',
                  label: ''
                }}
                size={isMobileView ? ButtonSize.full : ButtonSize.medium}
                disabled={data.propertyId === ''}
              >
                {' '}
                Update Account Manager
              </Button>

              <Button
                onClick={() => {
                  setShowDeleteModal(true);
                }}
                tracking={{
                  action: 'open',
                  category: 'blocked-date',
                  label: 'add-blocked-date-modal'
                }}
                type={ButtonType.primaryInverted}
                size={ButtonSize.medium}
              >
                Delete Account Manager
              </Button>
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center">
            <img
              src={`${PUBLIC_PATH}/assets/jpeg/add-guest.jpeg`}
              alt="assign accountManager"
              className="block mx-auto"
            />

            <Button
              onClick={() => {
                setShowAccountManagerUserModal(true);
                trackEvent('add', {
                  category: '',
                  label: ''
                });
              }}
              tracking={{
                action: 'cancel',
                category: '',
                label: ''
              }}
              size={isMobileView ? ButtonSize.full : ButtonSize.medium}
              disabled={data?.propertyId === ''}
            >
              {' '}
              Assign Account Manager
            </Button>
            {data?.propertyId === '' && (
              <span className="text-amber-600 mt-8 flex items-center justify-center">
                you can't assign a Account Manager to a unit that doesn't have property
              </span>
            )}
          </div>
        )}

        <ConfirmModal
          config={{ showModal: showConfirmModal, message: '' }}
          eventHandlers={{
            denyAction: () => {
              setShowConfirmModal(false);
              setShowAccountManagerUserModal(false);
            },
            confirmAction: () => {
              setShowConfirmModal(false);
              setShowAccountManagerUserModal(false);
              trackEvent('add', {
                category: '',
                label: ''
              });
            }
          }}
        />

        <ConfirmModal
          config={{
            showModal: showDeleteModal,
            message: 'Are you sure you want to delete this Account Manager?'
          }}
          eventHandlers={{
            denyAction: () => {
              setShowDeleteModal(false);
              setShowAccountManagerUserModal(false);
            },
            confirmAction: () => {
              setShowDeleteModal(false);
              setShowAccountManagerUserModal(false);
              eventHandlers.deleteAccountManager();
            }
          }}
        />
      </div>
      {showAccountManagerUserModal && (
        <AccountManagerPersonModal
          config={{ showModal: showAccountManagerUserModal }}
          eventHandlers={{
            closeHandler: () => {
              setShowAccountManagerUserModal(false);
            },
            chooseUser: (unitTypeModel: UnitTypeUiModel) => {
              eventHandlers.addAccountManager(unitTypeModel);
              setShowAccountManagerUserModal(false);
            }
          }}
        />
      )}
    </>
  );
};
